export default __webpack_public_path__ + "static/Rectangle4386-dd04669e85abb7bf0acc9fcb5e040a74.png";